import editBtn from "../../images/edit-btn.png"
import React,{useContext} from "react"
import {useGlobal} from "./Reducer"

 

   export default (props)=>
    {
        const [globalState, globalActions] = useGlobal();
        if(globalState.adminMode==false)
        {
           return null;
        }
        
        return (<div><img onClick={()=>{
                props.onClick();
        }} src={editBtn} /></div>);
    }
 
